import { TextContent } from "./types";

export interface ExtractionFieldInput {
  id: string;
  description: string;
}

export type AuthFetch = (
  url: string,
  options?: RequestInit
) => Promise<Response>;

export async function extractTextContent(
  freeText: string,
  fields: ExtractionFieldInput[],
  apiFetch: AuthFetch
): Promise<TextContent> {
  const response = await apiFetch(
    "/api/extract-text",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        freeText,
        fields,
      }),
    }
  );

  if (!response.ok) {
    const data = await response
      .json()
      .catch(() => null);

    throw new Error(
      data?.details ??
      data?.error ??
      "Fehler bei der Text-Extraktion"
    );
  }

  return response.json();
}